import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.no-border-radius]': 'hasNoBorderRadius',
    '[class.no-max-width]': '!limitedWidth',
    '[class]': 'variant',
  },
})
export class DropdownComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'rtl', 'long', 'white']];
  @ComponentVariant(DropdownComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public hasNoBorderRadius: boolean = false;
  @Input() public limitedWidth: boolean = true;
  @Input() public contextAlt: boolean = true;
}
